import { useContext } from 'react';
import { AppearanceContext, type AppearanceContextValue } from './AppearanceProvider';

/**
 * The only runtime writer of appearance state after mount
 * (d45_mode_wiring_decision.md §4 item 4). Must be used within an
 * `AppearanceProvider` — mounted once, alongside `ChakraProvider`, in main.tsx.
 */
export function useAppearance(): AppearanceContextValue {
  const context = useContext(AppearanceContext);
  if (!context) {
    throw new Error('useAppearance must be used within an AppearanceProvider');
  }
  return context;
}
